import React from 'react'
import { useAnimatedMesh } from './useAnimatedMesh'

const AnimatedMesh = () => {
  const meshRef = useAnimatedMesh()

  return (
    <mesh ref={meshRef}>
      <boxBufferGeometry args={[2, 2, 2]} />
      <meshStandardMaterial color="rgb(24, 203, 27, 1)" />
    </mesh>
  )
}

export default AnimatedMesh
